<template>
  <div ref="richText" v-bind="epiAttrs" data-rich-text class="rich-text">
    <div v-html="cContent" />
  </div>
</template>

<script lang="ts" setup>
import type { FieldResponseModelOfString } from '@api';

const props = defineProps<{
  content: FieldResponseModelOfString | string;
}>();

const epiAttrs = computed(() => typeof props.content !== 'string' && useEpiAttrs(props.content));

const cContent = computed(() =>
  typeof props.content === 'string' ? props.content : props.content.value
);

const richText = useTemplateRef('richText');

onMounted(() => {
  // Find all anchor links with href starting with #
  const anchorLinks = richText.value?.querySelectorAll('a[href^="#"]') || [];

  anchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href')?.substring(1);
      if (!targetId) return;
      const target = document.getElementById(String(targetId));

      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});
</script>
